import React, { useEffect } from "react";
import Swal from "sweetalert2";
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { modalCargando } from "./ui/sweetAlerts";

const IngresoIntranet = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const setPerfilUsuario = () => {
    // Si el token mantiene un perfil activo este lo redirecciona automaticamente
    localStorage.setItem('token', token);
    modalCargando("Ingresando...");
    redireccion();
  }

  const redireccion = () => {
    Swal.close();
    return navigate(`/`);  // Ruta por defecto si ningún caso coincide
  }

  useEffect(() => {
    setPerfilUsuario();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <></>
  );
};

export default IngresoIntranet;
